// Lib
import React, { forwardRef } from 'react';
import { TextField, Box } from '@mui/material';

// Styles
import { useStyles } from './InputStyles';

const Input = forwardRef(function Input(
  {
    withMask = false,
    value,
    label,
    required,
    className,
    error,
    onChange,
    customPlaceholder,
    maxLength,
    name,
    ...props
  },
  ref,
) {
  const { classes, cx } = useStyles({ error });

  return (
    <Box className={cx(className, classes.inputContainer)}>
      {label && (
        <Box className={classes.fieldLabel} mb={1}>
          {`${label} `}
          {required ? <span className={classes.required}>*</span> : ''}
        </Box>
      )}
      {customPlaceholder && customPlaceholder}
      <TextField
        name={name}
        error={!!error}
        className={classes.input}
        ref={ref}
        fullWidth={true}
        value={value}
        inputProps={{ accept: props.accept }}
        onChange={(e) => {
          if (withMask) {
            return onChange(e);
          }
          const { target } = e;
          let value = target?.value;
          const trimmedValue = value?.trimStart();
          if (trimmedValue?.length > maxLength) {
            const firstLetterPosition = value?.indexOf(trimmedValue[0]);
            value = value?.slice(0, maxLength + firstLetterPosition);
          }
          return onChange({ name, value, files: target?.files });
        }}
        {...props}
      />
      {error && (
        <div id="input-error" className={classes.error}>
          {error}
        </div>
      )}
    </Box>
  );
});

export default Input;
